export const environment = {
  production: false,
  demoMode: false,
  fastRemoteConfigFetch: false,
  pwa: true,
  version: '5.13.1',
  cloudServicesUrl: 'https://main-98126635921.europe-west1.run.app',

  firebase: {
    apiKey: 'AIzaSyD2OLwJgMBUCE9dETVqq7Lu9BX1uVXh9Gk',
    authDomain: 'site-audit-pro-dev.firebaseapp.com',
    databaseURL: 'https://site-audit-pro-dev.firebaseio.com',
    projectId: 'site-audit-pro-dev',
    storageBucket: 'site-audit-pro-dev.appspot.com',
    messagingSenderId: '851027748606',
    appId: '1:851027748606:web:5815f29fc490d663',
  },
  col: {
    USERS: 'users',
    FOLDERS: 'folders',
    PROJECTS: 'projects',
    ATTACHMENTS: 'attachments',
    CLIENTS: 'clients',
    ISSUES: 'issues',
    ASSIGNEES: 'assignees',
    IMAGES: 'images',
    SETTINGS: 'user_settings',
    USER_STATUS: 'user_status',
    BILLING: 'user_billing',
    STATS: 'user_stats',
    EXPORTS: 'exports',
    SUPPLEMENTARY: 'supplementary',
  },
};
